import { render, staticRenderFns } from "./AxRow.vue?vue&type=template&id=ecdc8f62"
import script from "./AxRow.vue?vue&type=script&lang=ts"
export * from "./AxRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports